<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top:100px;"
  >
    <!-- <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
    </div> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div v-show="template == 'default'">
                <div class="text-center mb-4">
                  <h3>{{ title }}</h3>
                  <h6 v-for="m in message" :key="m">
                    {{ m }}
                  </h6>

                  <h6 style="margin-top:20px;">
                    If you would like to join another meeting, please press the
                    following button.
                  </h6>
                </div>
                <div class="text-center">
                  <base-button type="primary" @click="go_home()"
                    >Join Another Meeting</base-button
                  >
                </div>
              </div>
              <div v-show="template == 'duplicate_session'">
                <div class="mb-4" style="color:black;text-align:left;">
                  <h3 class="text-center">Duplicate Session</h3>
                  <p>
                    You cannot join the meeting {{ case_id }} successfully
                    because:
                  </p>
                  <ul>
                    <li>
                      you have another session in the same meeting, duplicate
                      login is not allowed; or
                    </li>
                    <li>
                      the last meeting was not ended properly by the
                      coordinator, please try login a few minutes later. If the
                      same problem persists, you may contact your meeting
                      coordinator to reset the meeting.
                    </li>
                  </ul>

                  <h6 style="margin-top:20px;">
                    Please email courtav&itsupportteam@judiciary.hk for assistance.<br/>
                    If you would like to join another meeting, please press the
                    following button.
                    
                  </h6>
                  
                </div>
                <div class="text-center">
                  <base-button type="primary" @click="go_home()"
                    >Join Another Meeting</base-button
                  >
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "EndMeeting",
  data() {
    return {
      template: this.$route.params.template || "default",
      case_id: this.$route.params.case_id,
      title: this.$route.params.title,
      message: this.$route.params.message,
    };
  },
  methods: {
    logout() {
      axios
        .get(process.env.VUE_APP_WEB_HOST + "/auth/logout", {})
        .then(() => {
          console.log("logout");
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    go_home() {
      this.$router.push({
        name: "Home",
      });
    },
  },
  components: {},
  mounted() {
    this.logout();
  },
};
</script>

<style scoped>
p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
</style>
